import { generateNgrxServiceClient } from '@essent/ngrx-service-wrapper';
import { utilClient } from '@integration/api-client/util';

export const { actions: UtilApiActions, effects: UtilApiEffects } =
  generateNgrxServiceClient('Utils', utilClient);
